import Stack from '@mui/material/Stack';
import Meta from '../_tools/Meta';
import { Effizienz, EffizienzClass } from '../components/effizienz';

const EffizientClassesShowreel = () => {
    const height = 15;

    return (
        <>
            <Meta title="Showreel - Effizienz" />
            <Stack gap={2} direction="row" flexWrap="wrap" sx={{ color: 'text.primary' }}>
                <Effizienz stepHeight={height} type="stair" wltp />
                <Effizienz steps={{ combined: EffizienzClass.A, discharged: undefined }} stepHeight={height} type="stair" wltp />
                <Effizienz steps={{ combined: EffizienzClass.A, discharged: EffizienzClass.E }} stepHeight={height} type="stair" wltp />
                <Effizienz step={EffizienzClass.A} stepHeight={height} type="step" wltp />
            </Stack>
        </>
    );
};

export default EffizientClassesShowreel;
